import { injectArticleCampaigns } from './index';

const CAMPAIGN_MANAGER_SERVICE_PROD = 'https://plumbus.minutemediaservices.com';

injectArticleCampaigns(CAMPAIGN_MANAGER_SERVICE_PROD);
